import { useTranslation } from 'react-i18next';
import { LegalPageLayout, LegalSection } from './LegalPageLayout';

const STEPS = ['step1', 'step2', 'step3'] as const;

const FEATURES = [
  'feature1',
  'feature2',
  'feature3',
  'feature4',
  'feature5',
  'feature6',
  'feature7',
] as const;

const FAQS = ['faq1', 'faq2', 'faq3', 'faq4', 'faq5'] as const;

export function HelpPage() {
  const { t } = useTranslation();

  return (
    <LegalPageLayout titleKey="help.title">
      <LegalSection titleKey="help.quickStart">
        <ol className="mt-2 list-inside list-decimal space-y-2 text-muted-foreground">
          {STEPS.map((key) => (
            <li key={key}>{t(`help.${key}`)}</li>
          ))}
        </ol>
      </LegalSection>

      <LegalSection titleKey="help.features">
        <ul className="mt-2 list-inside list-disc space-y-1 text-muted-foreground">
          {FEATURES.map((key) => (
            <li key={key}>{t(`help.${key}`)}</li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection titleKey="help.faq">
        <div className="mt-2 space-y-4">
          {FAQS.map((key) => (
            <div key={key}>
              <p className="font-medium">{t(`help.${key}q`)}</p>
              <p className="mt-1 text-muted-foreground">{t(`help.${key}a`)}</p>
            </div>
          ))}
        </div>
      </LegalSection>
    </LegalPageLayout>
  );
}
